module.exports = __webpack_public_path__ + "static/media/image-not-found.002f5fac.png";